export function justificativaalteracaoencerrantesInRequest(params = {}) {
  return {
    type:
      '@justificativaalteracaoencerrantes/JUSTIFICATIVAALTERACAOENCERRANTES_IN_REQUEST',
    payload: { params },
  };
}

export function findJustificativaAlteracaoEncerrante(
  idjustificativaalteracaoencerrante
) {
  return {
    type:
      '@justificativaalteracaoencerrantes/FIND_JUSTIFICATIVAALTERACAOENCERRANTE',
    payload: { idjustificativaalteracaoencerrante },
  };
}

export function failedRequest() {
  return {
    type: '@justificativaalteracaoencerrantes/FAILED_REQUEST',
  };
}

export function deleteJustificativaAlteracaoEncerrante(
  idjustificativaalteracaoencerrante,
  params
) {
  return {
    type:
      '@justificativaalteracaoencerrantes/DELETE_JUSTIFICATIVAALTERACAOENCERRANTE',
    payload: { idjustificativaalteracaoencerrante, params },
  };
}

export function updateJustificativaAlteracaoEncerrante(
  justificativaalteracaoencerrante,
  params
) {
  return {
    type:
      '@justificativaalteracaoencerrantes/UPDATE_JUSTIFICATIVAALTERACAOENCERRANTE',
    payload: { justificativaalteracaoencerrante, params },
  };
}

export function storeJustificativaAlteracaoEncerrante(
  justificativaalteracaoencerrante,
  params
) {
  return {
    type:
      '@justificativaalteracaoencerrantes/STORE_JUSTIFICATIVAALTERACAOENCERRANTE',
    payload: { justificativaalteracaoencerrante, params },
  };
}

export function successInRequest(
  justificativaalteracaoencerrantes,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@justificativaalteracaoencerrantes/SUCCESS_IN_REQUEST',
    payload: {
      justificativaalteracaoencerrantes,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(justificativaalteracaoencerrante) {
  return {
    type: '@justificativaalteracaoencerrantes/SUCCESS_REQUEST',
    payload: { justificativaalteracaoencerrante },
  };
}

export function successRemove(params) {
  return {
    type: '@justificativaalteracaoencerrantes/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@justificativaalteracaoencerrantes/RECORD_FILTERING',
    payload: { params },
  };
}
